import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useInterval, useWhichEnd } from '@mail/m-hooks';
import Action from './action';

import Input from '../../../components/Input';
import WithLabelAction from '../../../components/WithLabelAction';
import Button from '../../../components/Button';

import { getSMSVerifyCode } from '../../../apis/DataReview';
import { IOption } from '../../../components/Select';

if (process.env.MAIL_APP_PLATFORM === 'h5') {
    require('./style_h5.scss');
} else {
    require('./style.scss');
}

interface IVerifyCodeInput {
    useLabel?: boolean,
    phoneNumber: string,
    phoneType: IOption,
    disableBtn?: boolean,
    errorText: string,
    verifyCode: string,
    handleOnChange: (code:string) => any,
    handleCheckOnBur: () => any,
    handleClick: (phone: string) => any
}


export const VerifyCodeInput: React.FC<IVerifyCodeInput> = ({ useLabel = true, verifyCode, errorText, phoneNumber, phoneType, handleClick, disableBtn, handleOnChange, handleCheckOnBur }) => {
    const whichEnd = useWhichEnd();
    const [waitSec, setWaitSec] = useState<number>(0);
    useInterval(() => {
        setWaitSec(waitSec - 1)
    }, waitSec > 0 ? 1000 : null)

    const onClick = async () => {
        if (waitSec > 0 || disableBtn) return;
        const phone = phoneType.id === '+86' ? phoneNumber: `${phoneType.id}-${phoneNumber}`;
        setWaitSec(60);
        handleClick(phone);
    }

    const renderContent = () => (
        <div className="verify-code-input-wrapper">
            <Input onChange={handleOnChange} errorText={errorText} onBur={() => handleCheckOnBur()} maxLength={6} inputId="verify-code-input" defaultValue={verifyCode} placeholder="请输入手机验证码" extraClass="verify-code-input" />
            <Button
                color={disableBtn ? "disabled" : (waitSec > 0 ? "disabled" : "secondry")}
                text={disableBtn ? "获取次数过多" : (waitSec > 0 ? `${waitSec}s重新获取` : "获取验证码")}
                onClick={() => onClick()}
                extraClass={(disableBtn || waitSec > 0) ? "verify-code-btn-disable" : "verify-code-btn"}
            />
        </div>
    );

    return (
        (!!whichEnd.h5 || !useLabel) ?
            renderContent() :
            <WithLabelAction label="手机验证码" htmlFor="verify-code-input" required={true} >
                {renderContent()}
            </WithLabelAction>
    )
}

interface IVerifyCodeInputContainer {
    useLabel?: boolean
}

const VerifyCodeInputContainer: React.FC<IVerifyCodeInputContainer> = ({ useLabel = true }) => {
    const { phoneNumber, phoneType } = useSelector((state: any) => state.PhoneInput);
    const { disableBtn, verifyCode, errorText } = useSelector((state: any) => state.VerifyCode);
    const dispatch = useDispatch();

    const handleClick = async (phone: string) => {
        const res = await getSMSVerifyCode({
            phone,
        });
        if (res && res.code === 314) {
            dispatch({
                type: Action.UPDATE_DISABLE_BTN,
                playload: true
            })
            dispatch({
                type: Action.UPDATE_VERIFY_PHONE_METHOD,
                playload: 'SMSBox',
            });
            dispatch({
                type: Action.UPDATE_VERIFY_INPUT_ERROR_TEXT,
                playload: '',
            });
            dispatch({
                type: Action.UPDATE_VERIFY_CODE,
                playload: "",
            });
        }
        if (res && res.code !== 200) {
            try {
                (window as any).mailStats.show('verifity_code_error', { errorText: res.desc })
            } catch(e) {}
        }
    }

    const handleOnChange = (code: string) => {
        dispatch({
            type: Action.UPDATE_VERIFY_CODE,
            playload: code
        })
        errorText && dispatch({
            type: Action.UPDATE_VERIFY_INPUT_ERROR_TEXT,
            playload: ''
        })
    }
    const handleCheckOnBur = () => {
        if (!verifyCode) {
            dispatch({
                type: Action.UPDATE_VERIFY_INPUT_ERROR_TEXT,
                playload: '请输入验证码'
            })
        }
    }

    return (
        <VerifyCodeInput 
            handleClick={handleClick}
            handleOnChange={handleOnChange}
            handleCheckOnBur={handleCheckOnBur}
            useLabel={useLabel}
            phoneNumber={phoneNumber}
            phoneType={phoneType}
            disableBtn={disableBtn}
            errorText={errorText}
            verifyCode={verifyCode}
        />
    )
}

export default VerifyCodeInputContainer;
